<template>
	<div class="guidelines-step">
		<div class="fixed-points">
			<div
				class="point-item"
				:class="[active == index ? 'active' : '']"
				v-for="(item, index) in step"
				:key="index"
				:style="
					[
						unactivecolor && typeof unactivecolor === 'string'
							? `background: ${unactivecolor};`
							: '',
						activecolor && typeof activecolor === 'string' && active == index
							? `background: ${activecolor};`
							: '',
					].join(';')
				"
				@click="allClick('change', index)"
			></div>
		</div>
		<div class="options-guidelines">
			<div class="options-guide-out" @click="allClick('out')" v-show="active == 0"> 退出指引 </div>
			<div class="options-guide-up" @click="allClick('up')" v-show="active > 0"> 上一步 </div>
			<div
				class="options-guide-next"
				@click="allClick('next')"
				v-show="active == 0 || step > active + 1"
			>
				下一步
			</div>
			<div class="options-guide-next" @click="allClick('over')" v-show="active + 1 == step">
				完成
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['active', 'step', 'unactivecolor', 'activecolor'],
		data() {
			return {
				timer: null,
			};
		},
		methods: {
			allClick(type, val) {
				this.$emit('allClick', type, val);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.guidelines-step {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 40px;

		.fixed-points {
			display: flex;
			align-items: center;
			.point-item.active {
				opacity: 1;
			}
			.point-item:active {
				opacity: 0.8;
			}
			.point-item {
				margin-right: 8px;
				width: 10px;
				height: 10px;
				background: #ffffff;
				border-radius: 50%;
				opacity: 0.5;
				cursor: pointer;
			}
		}
	}
	.options-guide-next {
		cursor: pointer;
		width: 100px;
		height: 40px;
		background: #e60000;
		text-align: center;
		line-height: 40px;
		font-size: 16px;
		font-weight: 500;
		color: #ffffff;
	}
	.options-guide-next:active,
	.options-guide-out:active,
	.options-guide-up:active {
		opacity: 0.7;
	}
	.options-guide-out,
	.options-guide-up {
		cursor: pointer;
		width: 100px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		font-size: 16px;
		font-weight: 500;
		color: #e60000;
		opacity: 0.75;
	}
	.options-guidelines {
		display: flex;
		align-items: center;
	}
</style>
